import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 🧾 Reporte Z (cortes Z de caja por rango de fechas)
 *
 * Backend esperado: branchId, dateFrom, dateTo
 */
export const reportZFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
